// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/user","layout":false,"id":"1"},"2":{"path":"/user/login","layout":false,"name":"login","parentId":"1","id":"2"},"3":{"path":"/user","redirect":"/user/login","parentId":"1","id":"3"},"4":{"path":"/user/*","parentId":"1","id":"4"},"5":{"path":"/dashboard","name":"dashboard","icon":"dashboard","parentId":"ant-design-pro-layout","id":"5"},"6":{"path":"/patient","name":"patient","icon":"user","parentId":"ant-design-pro-layout","id":"6"},"7":{"path":"/knowledge","name":"knowledge","icon":"book","parentId":"ant-design-pro-layout","id":"7"},"8":{"path":"/","redirect":"/dashboard","parentId":"ant-design-pro-layout","id":"8"},"9":{"path":"/*","parentId":"ant-design-pro-layout","id":"9"},"ant-design-pro-layout":{"id":"ant-design-pro-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import('./EmptyRoute')),
'2': React.lazy(() => import(/* webpackChunkName: "p__user__login__index" */'@/pages/user/login/index.tsx')),
'3': React.lazy(() => import('./EmptyRoute')),
'4': React.lazy(() => import(/* webpackChunkName: "p__404" */'@/pages/404.tsx')),
'5': React.lazy(() => import(/* webpackChunkName: "p__dashboard__workplace__Workplace" */'@/pages/dashboard/workplace/Workplace.tsx')),
'6': React.lazy(() => import(/* webpackChunkName: "p__patient__index" */'@/pages/patient/index.tsx')),
'7': React.lazy(() => import(/* webpackChunkName: "p__knowledge__index" */'@/pages/knowledge/index.tsx')),
'8': React.lazy(() => import('./EmptyRoute')),
'9': React.lazy(() => import(/* webpackChunkName: "p__404" */'@/pages/404.tsx')),
'ant-design-pro-layout': React.lazy(() => import(/* webpackChunkName: "t__plugin-layout__Layout" */'/Users/viv/projs/benai-admin/src/.umi-production/plugin-layout/Layout.tsx')),
},
  };
}
